module.exports = __webpack_public_path__ + "static/media/vip-week.8d6d6963.png";